const clickToCopy = (selector: string, element?: ParentNode) => {
  (element ?? document).querySelectorAll(selector).forEach((element) => {
    element.addEventListener('click', (e) => {
      navigator.clipboard.writeText((e.target as HTMLElement).innerText);
    });
    element.classList.add('click-to-copy');
  });
};

export { clickToCopy };
